const colors = {
	white: "#fff",
	dark: "#34495e",
	green: "#2ecc71",
	blue: "#3498db",
	orange: "#F79F1F",
	red: "#e55039",
	grey: "#596275"
}

const defaultTheme = "blue"
const defaultTitle = "Console"
const defaultBorderRadius = "5px"
const defaultLightenFactor = 0.37
const defaultDarkenFactor = 0.1

export {
	colors,
	defaultTheme,
	defaultTitle,
	defaultBorderRadius,
	defaultLightenFactor,
	defaultDarkenFactor
}
